export default function CopyToClipboard(sourceStr = '') {
    try {
        const inputDom = document.createElement('input');
        inputDom.setAttribute('readonly', 'readonly');
        inputDom.setAttribute('style', 'position: fixed; top:0; left:0; opacity:0;');
        inputDom.setAttribute('value', sourceStr);
        document.body.appendChild(inputDom);
        inputDom.setSelectionRange(0, sourceStr.length);
        inputDom.select();
        if (!navigator.clipboard) {
            document.execCommand('copy');
        } else {
            navigator.clipboard.writeText(inputDom.value);
        }
        document.body.removeChild(inputDom);
        return true;
    } catch (error) {
        return false;
    }
}
